import React from 'react';
import Money from '@hobs/components/Money/Money';
import Quantity from '@hobs/components/Quantity/Quantity';
import { expandDataItem } from '../expandItem';
import { DATE_FORMAT } from '@hobs/utils/constants';
import { format } from '@hobs/utils/formatWithTimeZone';

export const getAuditLogItemFieldValue = (value, dateValue, fieldName) => {
  const namesOfMoneyFields = ['price', 'cost', 'gross'];
  const fieldsToExclude = [
    'requestnumber',
    'servicecode',
    'latitudefrom',
    'longitudefrom',
    'comment',
    'servicedescription',
    'servicecode',
  ];
  const isNumber = dateValue
    ? false
    : !isNaN(Number.parseFloat(value)) &&
      !fieldsToExclude.some(x => fieldName.toLowerCase().includes(x));
  const isMoney =
    isNumber &&
    namesOfMoneyFields.some(x => fieldName.toLowerCase().includes(x));

  return (
    <td onClick={expandDataItem}>
      {dateValue ? (
        format(dateValue, DATE_FORMAT)
      ) : isMoney ? (
        <Money amount={value} />
      ) : isNumber ? (
        <Quantity amount={value} />
      ) : (
        value
      )}
    </td>
  );
};
